import {AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import {
  IDeterminationVictimizationTypeFormGroup
} from '../../services/forms/existing-case-filing-form/existing-case-filing-form.service';

/**
 * Validator function to check if the length of a FormArray is greater than or equal to the min value.
 * @param min
 */
export function minVictimizationTypeSelected(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fa = control as FormArray<FormGroup<IDeterminationVictimizationTypeFormGroup>>;
    if (fa.controls.filter(c => c.value.checked).length >= min) {
      return null;
    }
    return { 'minVictimizationTypeSelected': {valid: false }};
  }
}
